// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Ta7o","actions":"GroupTable_actions__3Q2TG","deleteModalFooter":"GroupTable_deleteModalFooter__BqSTW"};